import PropTypes from 'prop-types';
import * as SolidIcons from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Icon = ({ iName, style, className }) => {
  return <FontAwesomeIcon icon={SolidIcons[iName]} style={style} className={className} />;
};

Icon.propTypes = {
  iName: PropTypes.oneOf([
    'faAnglesLeft',
    'faAnglesRight',
    'faShareFromSquare',
    'faFileLines',
    'faBars',
    'faPlus',
    'faMobileScreenButton',
    'faArrowRightToBracket',
    'faPaperPlane',
    'faRotateRight',
    'faPen',
    'faChartLine',
    'faHouse',
    'faYenSign',
    'faClockRotateLeft',
    'faTrashCan',
    'faImage',
    'faCircleExclamation',
    'faCamera',
    'faCloudArrowUp',
  ]).isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default Icon;
